import React from 'react';

function Iframe(props) {
    const { className, item = {} } = props;
    const { attr = {} } = item;
    return (
        <div className={`dorik-iframe ${className}`}>
            <iframe
                {...attr}
                title={item.id}
                frameBorder="0"
                allowFullScreen
            ></iframe>
        </div>
    );
}

export default Iframe;
